

import { forwardRef, useContext } from 'react';

import { Icon } from '../icon/icon';
import { ButtonRootContext } from './context/button-root.context';
import { buttonIconRecipe } from './styles/button-icon.styles';
import type { ButtonIconPropsInterface } from './types/button-icon.types';

/**
 * @since 10.0.0
 */
export const ButtonIcon = forwardRef<SVGSVGElement, ButtonIconPropsInterface>(
  (props: ButtonIconPropsInterface, forwardedRef) => {
    const {
      tone = 'brand',
      emphasis = 'outlined',
      disabled = false,
      onImpact = false,
      size = 'md',
      loading = false,
    } = useContext(ButtonRootContext);
    const { children, css: cssProp, ...rest } = props;

    return (
      <Icon
        data-c11n-component="Button.Icon"
        data-c11n-version={__C11N_VERSION__}
        ref={forwardedRef}
        size={size === 'sm' ? 'sm' : 'md'}
        css={{
          ...buttonIconRecipe.raw({ tone, emphasis, disabled, onImpact, loading }),
          ...cssProp,
        }}
        {...rest}
      >
        {children}
      </Icon>
    );
  },
);

ButtonIcon.displayName = 'Button.Icon';
